module.exports = __webpack_public_path__ + "static/media/stage_logo.454fac85.png";